class ScrollRevealController {
  constructor() {
    // The 'scroll-reveal-ready' class is set synchronously in <head> (see
    // layout/theme.liquid) when motion is allowed and IntersectionObserver is
    // supported. If it's missing, the corresponding CSS never hides anything,
    // so there's nothing for this controller to reveal.
    if (!document.documentElement.classList.contains('scroll-reveal-ready')) return;

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1,
    });

    this.init();
  }

  init() {
    const main = document.getElementById('MainContent');
    if (!main) return;

    // Skip the first section (typically the above-the-fold hero, which has
    // its own dedicated entrance animation and is already visible on load).
    const sections = Array.from(main.querySelectorAll(':scope > .shopify-section')).slice(1);
    sections.forEach((section) => this.observer.observe(section));

    main.querySelectorAll('.product-card, .collection-card').forEach((item) => {
      this.observer.observe(item);
    });
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        this.observer.unobserve(entry.target);
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ScrollRevealController());
} else {
  new ScrollRevealController();
}
